import { render } from "./NewObjectFormDocuSign.vue?vue&type=template&id=a1fe1b12"
import script from "./NewObjectFormDocuSign.vue?vue&type=script&lang=js"
export * from "./NewObjectFormDocuSign.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__